import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { startUserSessionMonitor } from '../../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    selector: 'octo-uber',
    templateUrl: './uber.component.html',
    styleUrls: ['./uber.component.scss'],
})
export class UberComponent implements OnInit {
    constructor(public loaderService: LoaderService) {}

    ngOnInit(): void {
        startUserSessionMonitor();
        this.loaderService.hideLoader();
    }
}
